import ReportCategoryPersonaV2 from './reportCategoryPersonaV2'
export default ReportCategoryPersonaV2
